var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 18,
    height: 18,
    transform: "translate(-0.002)",
    fill: "#feb730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M264.464,281.561a4.342,4.342,0,0,0-1.318-2.782,4.508,4.508,0,0,0-2.987-1.21,58.76,58.76,0,0,0-8.056.09,4.105,4.105,0,0,0-3.522,3.163c-.389,1.385-.311,7.772-.084,9.141a4.12,4.12,0,0,0,3.272,3.554,48.545,48.545,0,0,0,9.013.06,4.133,4.133,0,0,0,3.567-3.256c.374-1.423.241-7.476.114-8.759m-1.5,8.138a2.757,2.757,0,0,1-2.591,2.46,48.261,48.261,0,0,1-8.4-.119,2.67,2.67,0,0,1-2.028-2.3,54.97,54.97,0,0,1,0-8.217,2.758,2.758,0,0,1,2.582-2.452,57.517,57.517,0,0,1,8.018.034A2.754,2.754,0,0,1,263,281.7a57.985,57.985,0,0,1-.034,8m-6.51-8.259a4.176,4.176,0,1,0,4.176,4.179,4.171,4.171,0,0,0-4.176-4.179m-.028,6.876a2.7,2.7,0,1,1,2.73-2.691,2.7,2.7,0,0,1-2.73,2.691m5.341-7.032a.977.977,0,1,1-.967-.984.969.969,0,0,1,.967.984",
    transform: "translate(-248.309 -277.477)",
    fill: "#feb730"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fad5d87e0fb3c2e9c5b12876fbae7a9b.svg";
export { ForwardRef as ReactComponent };